import { useTranslation } from 'react-i18next'
import { common } from '@ocean/ui'
import { IconType } from '@ocean/ui/dist/components/common/Icon/Icon'
import { Wrapper } from './AssessmentStatus.styled'

const { Icon, IconLabel, Typography } = common

export enum AssessmentStatusProgress {
  Ready = 'READY',
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Disapproved = 'DISAPPROVED',
}

export enum AssessmentStatusVariant {
  Rounded = 'ROUNDED',
}

export type AssessmentStatusProps = {
  progress?: AssessmentStatusProgress
  variant?: AssessmentStatusVariant
}

type StatusInfo = {
  icon: IconType
  label: string
}

const AssessmentStatus: React.FC<AssessmentStatusProps> = ({ progress, variant }) => {
  const { t } = useTranslation()
  if (!progress) return null

  function getStatusInfo(): StatusInfo {
    switch (progress) {
      case AssessmentStatusProgress.Pending:
        return { icon: 'checkCalendar', label: t('assessmentStatuses.pending') }
      case AssessmentStatusProgress.Approved:
        return { icon: 'checkCircle', label: t('assessmentStatuses.approved') }
      case AssessmentStatusProgress.Disapproved:
        return { icon: 'blocker', label: t('assessmentStatuses.disapproved') }
      case AssessmentStatusProgress.Ready:
      default:
        return { icon: 'checkCalendar', label: t('assessmentStatuses.ready') }
    }
  }

  const statusInfo = getStatusInfo()

  if (variant === AssessmentStatusVariant.Rounded)
    return (
      <Wrapper>
        <Typography variant='h3' uppercase dataTest='AssessmentStatus'>
          {statusInfo.label}
        </Typography>
      </Wrapper>
    )

  return (
    <IconLabel
      icon={<Icon icon={statusInfo.icon} />}
      label={statusInfo.label}
      dataTest='AssessmentStatus'
    />
  )
}

export default AssessmentStatus
